import React from 'react'
import { connect } from 'react-redux'
import PlanTeam from '../components/PlanTeam'

const PlanTeams = ({ teamList }) => (
  <div>
    {teamList.map(teamId =>  {
      return(
        <PlanTeam teamId={teamId} key={teamId} />
      )
    })} 
  </div> 
)

export default connect(
  state => ({
    teamList: state.organization.teamList
  })
)(PlanTeams)



// WEBPACK FOOTER //
// ./src/components/PlanTeams.js